import { SelectOption } from '@kanda-libs/ks-component-ts';

export const mapAprsToSelectOptions = (
  aprs: number[],
  showBNPL = false,
): SelectOption[] => {
  const base = aprs.map((apr) => ({
    name: `${apr / 100}% APR`,
    value: apr.toString(),
  }));
  if (!showBNPL) return base;
  return [
    ...base,
    {
      name: 'BNPL',
      value: 'BNPL',
    },
  ];
};
